<span [class.hidden]="!showTimer">{{ timerLabel }}</span>
